import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { selectContentTotalLength } from '../../selectors/ContentSelectors';
import { AppState } from '../../state/AppState';
import { MapStateToProps } from '../../utils/ConnectUtils';
import { AllCollectionsSpace, AllCollectionsSpaceOwnProps, AllCollectionsSpaceStateProps } from './AllCollectionsSpace';
import { selectSpaceInfo } from '~src/app/selectors/SpaceInfoSelectors';
import { SessionUserSelectors } from '~src/app/selectors/SessionInfoSelectors';

const mapStateToProps: MapStateToProps<AllCollectionsSpaceStateProps> = (state: AppState) => ({
  spaceInfo: selectSpaceInfo(state),
  numberOfFetchedCollections: selectContentTotalLength(state),
  isBusyFetchingItems: state.contentExplorer.content.isBusy,
  userDisplayName: SessionUserSelectors.sessionUserDisplayName(state)
});

export const ConnectedAllCollectionsSpace: React.ComponentClass<AllCollectionsSpaceOwnProps>
  = connect(mapStateToProps)(AllCollectionsSpace);
